const DOWNLOAD_ONLY = 'DOWNLOAD_ONLY';
const MIXED = 'MIXED';
const BOX_ONLY = 'BOX_ONLY';
const EMPTY = 'EMPTY';

export { DOWNLOAD_ONLY, MIXED, BOX_ONLY, EMPTY };
